import routerOptions0 from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}